import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core'
import * as SelectedItemActions from 'libs/gb-dashboard/item/data-access-selected-item/src/lib/+state/selected-item.actions'
import { SelectedItemFacade } from 'libs/gb-dashboard/item/data-access-selected-item/src/lib/+state/selected-item.facade'
import { GbItemSelectStore } from './gb-item-select.store'
import { FormControl } from '@angular/forms'
import { take } from 'rxjs'
import { gbCheckLoaded } from '@galabid/shared/utils/operators'
import { ItemsFilters, SlimItemsEntity } from 'libs/gb-dashboard/item/data-access/src/lib/+state/items.models'
import { toSignal } from '@angular/core/rxjs-interop'

@Component({
  selector: 'gb-item-select',
  templateUrl: './gb-item-select.component.html',
  styleUrls: ['./gb-item-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [GbItemSelectStore],
  standalone: false,
})
export class GbItemSelectComponent implements OnInit, OnDestroy {
  @Input() control = new FormControl()
  @Input() labelTranslateKey = ''
  @Input() hintTranslateKey = ''
  @Input() filters?: ItemsFilters
  @Output() selectedOptionChanged = new EventEmitter<SlimItemsEntity>()
  @Output() selectedOptionClear = new EventEmitter<void>()

  loading$ = this.gbItemSelectStore.loading$
  items$ = this.gbItemSelectStore.items$
  selectedItem$ = this.selectedItemFacade.selectedItem$
  search = toSignal(this.gbItemSelectStore.search$)

  constructor(
    private gbItemSelectStore: GbItemSelectStore,
    private selectedItemFacade: SelectedItemFacade,
  ) {}

  ngOnInit(): void {
    this.loadInitialItems()
    // NOTE: Initially, the selected item is just the uuid, so we need to sync it
    if (this.control.value) {
      this.selectedItemFacade.dispatch(SelectedItemActions.syncSelectedItem({ uuid: this.control.value }))
    }
    this.selectedItem$
      .pipe(gbCheckLoaded(this.selectedItemFacade.loaded$), take(1))
      .subscribe((selectedItem) => this.control.setValue(selectedItem))
  }

  ngOnDestroy(): void {
    this.selectedItemFacade.dispatch(SelectedItemActions.clearSelectedItem())
  }

  loadInitialItems(): void {
    this.gbItemSelectStore.loadInitialItems(this.filters)
  }

  onSearch(search: string): void {
    this.gbItemSelectStore.searchItems(search)
  }

  onChange(item: SlimItemsEntity): void {
    this.selectedOptionChanged.emit(item)
  }

  onScrollToEnd(): void {
    this.gbItemSelectStore.loadItemsNextPage()
  }

  onClear(): void {
    this.selectedOptionClear.emit()
    this.loadInitialItems()
  }

  /**
   * Handles the dropdown close event.
   * Reloads items if dropdown closed while search
   * active to ensure filtered results are reset.
   */
  onClose(): void {
    if (this.search()) this.loadInitialItems()
  }
}
